import { memo } from 'react';

import { FormFieldControlledComponent } from '../../../types';
import { useAccordionRadioGroups } from './hooks/useAccordionRadioGroups';
import { AccordionRadioGroupInputProps } from './types/AccordionRadioGroupsInputProps';
import { AccordionRadioGroupsProps } from './types/AccordionRadioGroupsProps';
import { AccordionRadioGroupsSelecter } from './AccordionRadioGroupsSelecter';
import { SelectedAccordionRadioOption } from './SelectedAccordionRadioOption';

const AccordionRadioGroupsComponent = ({
  _ref,
  groups,
  hooks,
  invalid,
  name,
  onChange,
  onBlur,
  value,
  footer,
  cardProps,
}: AccordionRadioGroupInputProps) => {
  const {
    onSelectedOptionChange,
    onClearSelectedOption,
    selectedGroup,
    selectedOption,
  } = useAccordionRadioGroups({
    name,
    hooks,
    groups,
    value,
    onChange,
  });

  if (selectedGroup && selectedOption) {
    return (
      <SelectedAccordionRadioOption
        cardProps={cardProps}
        footer={footer}
        onClearSelectedOption={onClearSelectedOption}
        selectedGroup={selectedGroup}
        selectedOption={selectedOption}
      />
    );
  }

  return (
    <AccordionRadioGroupsSelecter
      _ref={_ref}
      groups={groups}
      invalid={invalid}
      name={name}
      onBlur={onBlur}
      onChange={onSelectedOptionChange}
      value={value}
    />
  );
};

export const AccordionRadioGroups = memo(
  AccordionRadioGroupsComponent,
) as FormFieldControlledComponent<number | string, AccordionRadioGroupsProps>;

AccordionRadioGroups.controlled = true;
AccordionRadioGroups.displayName = 'AccordionRadioGroups';
